var map = {
	"./Body.vue": 9508,
	"./Btn.vue": 3494,
	"./DialogCam.vue": 9394,
	"./DialogDel.vue": 7304,
	"./DialogImg.vue": 7343,
	"./Heading.vue": 8460,
	"./Img.vue": 3815,
	"./Section.vue": 7223,
	"./Subheading.vue": 5460,
	"./Subtitle.vue": 5950,
	"./Title.vue": 1854
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8873;